import type { IEndpointBasicAuthentication } from '@deity-io/di-data-flows';
import { Input } from '@deity-io/portal-ui';
import type { FC } from 'react';

interface IAuthorizationProps {
  isEditable: boolean;
  authentication?: Partial<IEndpointBasicAuthentication>;
  parent?: Partial<IEndpointBasicAuthentication>;
  onChange: (key: string[], value: any | null, set?: boolean) => void;
}

const BasicAuthentication: FC<IAuthorizationProps> = ({ isEditable, authentication, parent, onChange }) => (
  <>
    <Input
      label={!authentication?.username ? `${parent?.username} (inherited)` : 'Username'}
      type="text"
      name="username"
      id="username"
      value={(authentication as IEndpointBasicAuthentication)?.username}
      onChange={e => onChange(['authentication', 'username'], e.target.value)}
      placeholder="Enter username"
      disabled={!isEditable}
      sx={{ marginY: 2 }}
      autoComplete="off"
    />
    <Input
      label={!authentication?.password ? `***** (inherited)` : 'Password'}
      type="password"
      name="password"
      id="password"
      value={(authentication as IEndpointBasicAuthentication)?.password}
      onChange={e => onChange(['authentication', 'password'], e.target.value)}
      placeholder="Enter password"
      disabled={!isEditable}
      sx={{ marginY: 2 }}
      autoComplete="off"
    />
  </>
);

export default BasicAuthentication;
